<template>
  <div
    ref="scrollbarRoot"
    class="custom-scrollbar-container"
    :class="{ 'custom-scroll-accent': !defaultStyle }"
    :tabindex="keyboardAccessible ? 0 : undefined"
    :role="keyboardAccessible ? 'region' : undefined"
    :aria-label="
      keyboardAccessible && scrollRegionLabel ? scrollRegionLabel : undefined
    "
  >
    <perfect-scrollbar
      :id="scrollerId"
      :class="scrollComponentClass"
      :options="settings"
      @ps-scroll-y="emitEvent"
      @ps-scroll-x="emitEvent"
    >
      <slot></slot>
    </perfect-scrollbar>
  </div>
</template>

<script>
import { stripPerfectScrollbarThumbTabindex } from "@/helpers/stripPerfectScrollbarThumbTabindex.js"

export default {
  props: {
    settings: {
      type: Object,
      default: function () {
        return {}
      }
    },
    scrollComponentClass: [Array, String],
    scrollerId: String,
    defaultStyle: Boolean,
    /** When true, the scrollable region is in the tab order (arrow keys / keyboard access). */
    keyboardAccessible: {
      type: Boolean,
      default: false
    },
    /** Short name for the scrollable region (required for keyboardAccessible). */
    scrollRegionLabel: {
      type: String,
      default: ""
    }
  },
  setup(props, { emit }) {
    const emitEvent = (event) => {
      emit(event.type, event)
    }

    return {
      emitEvent
    }
  },
  mounted() {
    const scrollbarRoot = this.$refs.scrollbarRoot
    if (!scrollbarRoot?.querySelectorAll) {
      this._psThumbObserver = null
      return
    }

    this.$nextTick(() => {
      stripPerfectScrollbarThumbTabindex(scrollbarRoot)
    })
    if (typeof MutationObserver !== "undefined") {
      this._psThumbObserver = new MutationObserver(() => {
        stripPerfectScrollbarThumbTabindex(scrollbarRoot)
      })
      if (scrollbarRoot) {
        this._psThumbObserver.observe(scrollbarRoot, {
          subtree: true,
          childList: true
        })
      }
    } else {
      this._psThumbObserver = null
    }
  },
  beforeUnmount() {
    this._psThumbObserver?.disconnect()
    this._psThumbObserver = null
  }
}
</script>
